import { render, staticRenderFns } from "./lideranca.vue?vue&type=template&id=3c8cc38c"
import script from "./lideranca.vue?vue&type=script&lang=js"
export * from "./lideranca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports